import { FC } from 'react';
import * as Model from './article2_model';
import '../ArticleComponent.scss';
import './Article2.scss';
import { ButtonComponent } from '../../../UI/ButtonComponent/ButtonComponent';
const Article2Component: FC = () => {
	const handleNavigate = () => {
		window.open(Model.Links.beacon_discovery, '_blank', 'noopener');
	};
	const handleImgBeaconDiscovery = () => {
		window.open(Model.Links.beacon_discovery, '_blank', 'noopener');
	};
	const handleImgBoneSuckin = () => {
		window.open(Model.Links.bone_suckin, '_blank', 'noopener');
	};
	const handleImgMarkeyReadyInsights = () => {
		window.open(Model.Links.market_ready_insights, '_blank', 'noopener');
	};

	return (
		<div className='page second'>
			<div className='section--intro'>
				<div className='section-container'>
					<h3 className='section-heading'>{Model.Section1.heading}</h3>
					<p className='info-600'>
						<span>August in Denver means one thing for the natural products community: </span>
						<a href={Model.Links.newtopia} target='_blank' rel='noopener'>
							Newtopia Now
						</a>
						<span>{Model.Section1.content1}</span>
					</p>
					<p>
						<span className='info-400'>
							Retailers aren’t waiting until they arrive in Denver to start scouting. They’re
							already combing through{' '}
						</span>
						<a
							href={Model.Links.beacon_discovery}
							className='info-400'
							target='_blank'
							rel='noopener'
						>
							Beacon Discovery
						</a>
						<span className='info-400'>{Model.Section1.content2}</span>
					</p>
					<p className='info-400'>{Model.Section1.content3}</p>
				</div>
			</div>

			<div className='section--image-left-wave second-first'>
				<div className='section-container space-req-two'>
					<h3 className='section-heading'>{Model.Section2.heading}</h3>
					<p className='info-600'>{Model.Section2.content1.heading}</p>

					<div className='imageLeftContentRight'>
						<div className='image'>
							<img
								src={Model.Images.update_brand}
								alt='Filters'
								onClick={handleImgBeaconDiscovery}
							/>
						</div>
						<div className='content'>
							<ul>
								<li>
									<span className='info-400'>{Model.Section2.content1.subcontent.content1}</span>
								</li>
								<li>
									<span className='info-400'>{Model.Section2.content1.subcontent.content2}</span>
								</li>
								<li>
									<span className='info-400'>{Model.Section2.content1.subcontent.content3}</span>
								</li>
								<li>
									<span className='info-400'>{Model.Section2.content1.subcontent.content4}</span>
								</li>
							</ul>
						</div>
					</div>
					<p className='info-400'>{Model.Section2.content2}</p>
				</div>
			</div>

			<div className='section--image-right second-second'>
				<div className='section-container'>
					<h3 className='section-heading'>{Model.Section3.heading}</h3>
					<p className='info-600 nospace'>{Model.Section3.content1.subcontent.heading}</p>
					<div className='imageRightContentLeft nospace'>
						<div className='content'>
							<ul>
								<li>
									<span className='info-700'>
										{Model.Section3.content1.subcontent.content1.boldcontent}
									</span>
									<span className='info-400'>
										{Model.Section3.content1.subcontent.content1.content}
									</span>
								</li>
								<li>
									<span className='info-700'>
										{Model.Section3.content1.subcontent.content2.boldcontent}
									</span>
									<span className='info-400'>
										{Model.Section3.content1.subcontent.content2.content}
									</span>
								</li>
								<li>
									<span className='info-700'>
										{Model.Section3.content1.subcontent.content3.boldcontent}
									</span>
									<span className='info-400'>
										{Model.Section3.content1.subcontent.content2.content}
									</span>
								</li>
							</ul>
							<p className='info-400'>{Model.Section3.content2}</p>
						</div>
						<div className='image'>
							<img src={Model.Images.mustard} onClick={handleImgBoneSuckin} />
							<img src={Model.Images.wings} className='middle' onClick={handleImgBoneSuckin} />
							<img src={Model.Images.wings_description} onClick={handleImgBoneSuckin} />
						</div>
					</div>
				</div>
			</div>

			<div className='section--image-right second-override'>
				<div className='section-container'>
					<h3 className='section-heading'>{Model.Section4.heading}</h3>
					<div className='imageRightContentLeft'>
						<div className='content'>
							<p className='info-400'>{Model.Section4.content1}</p>
							<a
								href={Model.Links.market_ready}
								className='info-400'
								target='_blank'
								rel='noopener'
							>
								MarketReady Verified
							</a>

							<span className='info-400'> badge</span>
						</div>
						<div className='image'>
							<img src={Model.Images.market_ready} onClick={handleImgMarkeyReadyInsights} />
						</div>
					</div>
					<p className='info-400'>This distinction shows you’ve worked with the experts at </p>
					<a
						href={Model.Links.market_ready_insights}
						className='info-400'
						target='_blank'
						rel='noopener'
					>
						MarketReady Insights
					</a>{' '}
					<span className='info-400'>{Model.Section4.content2}</span>
				</div>
			</div>

			<div className='section--noimage third-override'>
				<div className='section-container'>
					<h3 className='section-heading'>{Model.Section5.heading}</h3>
					<p className='info-600'>{Model.Section5.content1}</p>
					<p className='info-400'>{Model.Section5.content2}</p>
					<div className='button-container'>
						<ButtonComponent
							text={'GET READY TO BE DISCOVERED!'}
							onClick={handleNavigate}
							style={'rounded-button primary addToCart'}
							icon={<i className='ri-arrow-right-s-line arrowIcon'></i>}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Article2Component;
